import { IconButton, Tooltip } from '@mui/material';
import MarkEmailUnreadIcon from '@mui/icons-material/MarkEmailUnread';
import { useCreateNavigationTargetPath } from './useCreateNavigationTargetPath';
import { useMemo } from 'react';

interface DeadLetterQueueButtonProps {
  documentId?: string | null;
  userId?: string | null;
  collectionName?: string | null;
  tooltip?: string;
}

export const DeadLetterQueueButton = ({
  documentId,
  userId,
  collectionName,
  tooltip = 'View in Dead Letter Queue',
}: DeadLetterQueueButtonProps) => {
  const filters = useMemo(
    () => ({
      documentId,
      userId,
      collectionName: [collectionName],
    }),
    [documentId, userId, collectionName],
  );

  const targetPath = useCreateNavigationTargetPath(
    'deadLetterQueue',
    filters,
  );

  return (
    <Tooltip title={tooltip}>
      <IconButton
        component="a"
        href={targetPath}
        sx={{
          '&:hover': {
            textDecoration: 'none',
          },
        }}
      >
        <MarkEmailUnreadIcon />
      </IconButton>
    </Tooltip>
  );
};
